"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function onLoad() {
    const url = new URLSearchParams(window.location.search);
    const customer_posted = url.get('customer_posted');
    if (customer_posted && Boolean(customer_posted)) {
        const popup = document.querySelector('.popup--subscribed');
        if (popup) {
            popup.classList.add("popup");
        }
    }
}
document.addEventListener('DOMContentLoaded', onLoad);
